export class Quanlyhoidaptructuyen {
    id : number;
    tieude : string;
    noidung : string;
    ghichu : string;
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifiedbyuserid: number;
    modifieddate: Date; 
    
    hienthi : number;
    donviid : number;
    tendonvi:string;
    hoten:string;
    namsinh:number;
    gioitinh:number;
    diachi:string;
    email:string;
    traloi:string;
    canboid:number;

    tengioitinh:string;
}